import { render, staticRenderFns } from "./LatestInspection.vue?vue&type=template&id=6aa81c26&"
import script from "./LatestInspection.vue?vue&type=script&lang=js&"
export * from "./LatestInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports